// import { client } from './yourApolloClient'; // Import your Apollo client instance
import { browserHistory } from 'react-router'; // For redirecting to another page
import client from '../Graphql/client';
 
// Common method to handle GraphQL queries
// const token = localStorage.getItem('authToken');
// export const fetchData = async (query, variables = {}) => {
//     const token = localStorage.getItem('authToken');
//     // Check if token is missing and redirect
//     if (!token) {
//         console.warn("Token is missing. Redirecting to login...");
//         window.location.href = 'http://localhost/'; // Redirect to login
//         return; // Stop further execution
//     }
//     try {
//         const res = await client.query({
//             query,
//             variables,
//             fetchPolicy: "no-cache",
//             context: {
//                 headers: {
//                     authorization: `Bearer ${token}`,
//                 },
//             },
//         });
//         return res;
//     } catch (error) {
//         console.log(error.message)
//         // Check if the error is Unauthorized (401)
//         if (error.message.includes("Unauthorized")) {
//             localStorage.removeItem('authToken'); // Clear the invalid token
//             // Redirect to the login page or another URL if the token is invalid or expired
//             window.location.href = 'http://localhost/'; // Or you can use browserHistory.push('/login') if using React Router
//         }
//         throw new Error(error.message || 'Unidentified Error');
//     }
// };
 
//#region New Code
 
export const fetchData = async (query, variables = {}) => {
    const token = localStorage.getItem('authToken');
 
    // Check if token is missing
    if (!token) {
        localStorage.removeItem('authToken')
        console.warn("Token is missing. Redirecting to login...");
        redirectToLogin();
        return; // Stop further execution
    }
 
    try {
        const res = await client.query({
            query,
            variables,
            fetchPolicy: "no-cache",
            context: {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            },
        });
        return res;
    } catch (error) {
        console.error("Error in fetchData:", error.message);
 
        // Handle Unauthorized (401) error
        if (error.message.includes("Unauthorized")) {
            handleUnauthorizedError();
        }
 
        throw new Error(error.message || 'Unidentified Error');
    }
};
// Helper function to handle redirection to the login page
const redirectToLogin = () => {
    // Redirect only if not already on the login page
    if (window.location.pathname !== '/') {
        localStorage.removeItem('authToken')
        window.location.href = 'https://app.strivere.com/';
    }
};
 
// Helper function to handle Unauthorized (401) error
const handleUnauthorizedError = () => {
    console.warn("Token is invalid or expired. Redirecting to login...");
    localStorage.removeItem('authToken'); // Clear the invalid token
    redirectToLogin();
};
 
//#endregion
 
// Common method to handle GraphQL mutations (for Create/Update)
export const mutateData = async (mutation, variables = {}) => {
    try {
        const token = localStorage.getItem('authToken');
        const res = await client.mutate({
            mutation,
            variables,
            context: {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            },
        });
        return res;
    } catch (error) {
        console.log(error.message)
        // Check if the error is Unauthorized (401)
        if (error.message.includes("Unauthorized")) {
            localStorage.removeItem('authToken');
            // Redirect to the login page or another URL if the token is invalid or expired
            window.location.href = 'https://app.strivere.com/'; // Or you can use browserHistory.push('/login') if using React Router
        }
        throw new Error(error.message || 'Unidentified Error');
    }
};